export const REQUEST_ENDPOINT_ZAPPIER = "https://hooks.zapier.com/hooks/catch/10364333/bwgxhuv/"

export const COUNTRY_OPTIONS = [{ label: "Colombia", value: "Q291bnRyeU5vZGU6NDk=" }]
